import {
  OrgAnalyticsDimensionType,
  OrganizationAnalyticsQuery
} from 'graphql/types';

export const colorSet = {
  'time-entry-billable-duration': '#26D293',
  'time-entry-non-billable-duration': '#D2F9EA',
  'unaccounted-hours': '#93B0D0',
  remaining: '#CDDBFE'
} as Record<string, string>;

export type dataSetProp = {
  x: string;
  y: number;
  id: string;
  value: number;
};

export type resultDataSetProp = {
  x: string;
  y: number;
  id: string;
  color: string;
  value: number;
};

export type transformAnalyticsDataProps = {
  dataSet: resultDataSetProp[][] | undefined;
  scheduledHours: number;
};

export function transformAnalyticsData(
  data: OrganizationAnalyticsQuery | undefined
): transformAnalyticsDataProps {
  if (!data) {
    return { dataSet: [] as resultDataSetProp[][], scheduledHours: 0 };
  }
  let scheduledHours = 0;
  let billableAndNonBillableHours = 0;

  const dataSet = data?.orgAnalytics?.analyticsResult?.items.reduce(
    (acc, _data) => {
      if (
        _data?.dimension?.dimensionType ===
        OrgAnalyticsDimensionType.MetricsByHoursSummary
      ) {
        const dataId = _data?.dimension?.id as string;

        const result = {
          x: 'HOURS',
          y: _data?.metrics?.totalDuration,
          id: dataId,
          value: _data?.metrics?.totalDuration
        };

        if (
          result.id === 'time-entry-billable-duration' ||
          result.id === 'time-entry-non-billable-duration'
        ) {
          billableAndNonBillableHours += result.y;
        }

        if (dataId === 'work-schedule') {
          scheduledHours = result.y;
        } else {
          acc.push(result);
        }

        return acc;
      } else {
        return acc;
      }
    },
    [] as dataSetProp[]
  );

  dataSet?.sort((a, b) => a.id.localeCompare(b.id));

  const remaining = {
    x: 'HOURS',
    y: Math.max(scheduledHours - billableAndNonBillableHours, 0),
    id: 'remaining',
    value: scheduledHours - billableAndNonBillableHours
  } as dataSetProp;

  dataSet?.push(remaining);

  const totalValue =
    dataSet?.reduce((a, c) => {
      a += c.y;
      return a;
    }, 0) ?? 25;

  const minWidth = 22;

  const resultDataSet = dataSet?.map((d: dataSetProp) => {
    return [
      {
        x: d.x,
        y: Math.max((d.y / totalValue) * 100, minWidth),
        id: d.id,
        color: colorSet[d.id],
        value: d.value
      }
    ];
  });
  return {
    dataSet: resultDataSet as resultDataSetProp[][],
    scheduledHours: scheduledHours
  };
}
